import React from 'react'
import { Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PrivateRoute = (route: any) => {
  const title = route.title
    ? `${route.title} | Xfers, Internet Banking Payments Made Easy`
    : 'Xfers, Internet Banking Payments Made Easy'

  return (
    <Route
      sensitive
      path={route.path}
      render={props => (
        <>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <route.component {...props} routes={route.routes} />
        </>
      )}
    />
  )
}

export default PrivateRoute
